var _style, _path, _polygon, _path2, _polygon2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-c2c19df5-e7e6-4928-a917-faade4bc02f2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 194.6 41.8",
    style: {
      enableBackground: "new 0 0 194.6 41.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4AAE4D;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#48AE4D;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.9,8.9c-0.5,1.1-1.3,2.3-2.3,3.3c4,2,6.8,6.2,6.8,10.9c0,6.8-5.6,12.3-12.5,12.3c-6.9,0-12.5-5.5-12.5-12.3 c0-5,3-9.3,7.4-11.2c-0.1-1.3,0-2.9,0.7-4.5c-7,1.9-12.1,8.2-12.1,15.7c0,9,7.4,16.3,16.5,16.3s16.5-7.3,16.5-16.3 C148.4,17,145,11.6,139.9,8.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "11.1,36.2 16.5,36.2 16.5,12.7 25.2,12.7 25.2,7.7 2.4,7.7 2.4,12.7 11.1,12.7 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.4,24.6l1-0.9c0.2-0.2,0.4-0.4,0.6-0.6c1.7-1.8,2.5-3.8,2.5-6.4c0-2.8-0.8-4.9-2.6-6.6 c-1.8-1.7-3.7-2.5-6-2.5H32.2v28.5h5.3V25.8h4.1L49,36.2h7.1L47.4,24.6L47.4,24.6z M44.6,19.6L44.6,19.6c-0.8,0.8-1.8,1.2-2.9,1.2 h-4.2v-8.1h4.2c1.1,0,2.1,0.4,2.9,1.2c0.8,0.8,1.2,1.8,1.2,2.9S45.4,18.9,44.6,19.6L44.6,19.6z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "79.8,12.6 79.8,7.7 64.6,7.7 64.6,36.2 79.8,36.2 79.8,31.4 69.9,31.4 69.9,22.9 78.5,22.9 78.5,19  69.9,19 69.9,12.6 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.7,35.1l10.3-26.7h2.2L99.8,37.7h-2L86.2,8.4h2.2L98.7,35.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.9,35.9H173v1.9h-16.1V8.4h1.9L158.9,35.9L158.9,35.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.9,8.4h22.8v1.8h-10.4v27.6h-2V10.2h-10.4L169.9,8.4L169.9,8.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M127.8,13.5c-0.2-1.1-0.7-4,0.9-6.8c2.1-3.7,6.7-5.6,11.6-4.8c0,0,1.1,8.1-5.6,11.6c0,0-5.4,2.6-6.3,4.5 c0,0,0-6.3,9.1-13.7c-1.1,0.4-2.3,1-3.6,1.9C130.4,8.6,128.6,11.7,127.8,13.5L127.8,13.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ce292545c4a26aff1823e28f1dadcb41.svg";
export { ForwardRef as ReactComponent };